import { MessageCircle } from "lucide-react";
import { config, whatsappUrl, scrollToId } from "../config";

export const Footer = () => (
  <footer data-testid="footer-section" className="border-t border-slate-800 bg-slate-950 py-12 text-slate-400">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:grid-cols-3 sm:px-6 lg:px-8">
      <div>
        <p className="text-lg font-semibold text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
          {config.brand.name}
        </p>
        <p className="mt-1 text-sm">{config.brand.product}</p>
        <p className="mt-3 text-xs text-slate-500">{config.brand.domain} · Paraguay</p>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Secciones</p>
        <div className="mt-3 flex flex-col gap-2">
          {[
            ["El diferencial Plus", "diferencial"],
            ["Ejemplos", "ejemplos"],
            ["Cómo funciona", "como-funciona"],
            ["Preguntas frecuentes", "faq"],
          ].map(([label, id]) => (
            <button
              key={id}
              data-testid={`footer-link-${id}`}
              onClick={() => scrollToId(id)}
              className="w-fit text-sm transition-colors hover:text-white"
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Contacto y legal</p>
        <div className="mt-3 flex flex-col gap-2">
          <a
            data-testid="footer-whatsapp-link"
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex w-fit items-center gap-2 text-sm transition-colors hover:text-white"
          >
            <MessageCircle className="h-4 w-4 text-emerald-400" />
            WhatsApp
          </a>
          <a data-testid="footer-privacy-link" href={config.links.privacy} className="w-fit text-sm transition-colors hover:text-white">
            Política de privacidad
          </a>
          <a data-testid="footer-terms-link" href={config.links.terms} className="w-fit text-sm transition-colors hover:text-white">
            Términos y condiciones
          </a>
        </div>
      </div>
    </div>
    <div className="mx-auto mt-10 max-w-7xl border-t border-slate-800 px-4 pt-6 text-xs text-slate-500 sm:px-6 lg:px-8">
      © {new Date().getFullYear()} {config.brand.name} · {config.brand.product}. Todos los derechos reservados.
    </div>
  </footer>
);
